export default {
    messages: {
        _default: (field) => `O campo ${field} não é válido`,
        required: (field) => `O campo ${field} é obrigatório`
      },
      attributes: {
          payer: {
              full_name: 'Nome completo',
              email: 'Correio eletrônico',
              phone: 'Telefone',
          },
          billing_address: {
              street1: 'Endereço',
              city: 'Cidade',
              postal_code: 'Código postal',
              country: 'Country',
          },
          credit_card: {
              number: 'Número',
              security_code: 'Código de segurança',
              expiration_date: 'Data de expiração',
          },
      },
};
